<div class="div-arriere-plan-action" (click)="cancelDetails($event)"></div>
<div class="div-global-action" (click)="cancelDetails($event)">
  <div id="center-square" class="flex content-center">
    <div class="text-holder ">
      <!-- HEADER EMAIL SENT -->
      <div *ngIf="recoverSucceeded === true" class="flex-col text-center align-items-center">
        <div class="flex align-items-center gap-20 mb-20">
          <h2 class="bold title-text no-margin light-blue text-xl">E-MAIL ENVOYÉ</h2>
          <img src="assets/recover-success-icon.svg" id="logo">
        </div>
      </div>

      <!-- HEADER EMAIL NOT SENT -->
      <div *ngIf="recoverSucceeded === false" class="flex-col text-center align-items-center">
        <div class="flex align-items-center gap-20 mb-10">
          <h2 class="bold title-text no-margin red text-xl">ADRESSE INTROUVABLE</h2>
          <img src="assets/recover-failure-icon.svg" id="logo">
        </div>
      </div>

      <div *ngIf="recoverSucceeded === true" class="text-center">
        <p class="light-blue text-lg no-margin">Votre invitation à voter a été envoyée à</p>
        <p class="dark-blue bold flex content-center gap-20 text-lg">{{email}}</p>
      </div>

      <div *ngIf="recoverSucceeded === false" class="text-center">
        <!-- <p class="red text-lg mb-10">L’adresse e-mail</p> -->
        <p class="red text-lg no-margin">Aucun scrutin en cours associé à l’adresse</p>
        <!-- <p class="dark-blue bold flex align-items-center gap-20 text-lg mb-10">{{email}}</p> -->
        <p class="dark-blue bold flex content-center gap-20 text-lg mb-10">{{email}}</p>
        <!-- <p class="red mb-10">n’a pas été trouvée dans un scrutin en cours.</p> -->
      </div>

      <div class="flex-col content-center align-items-center gap-20">
        <button (click)="close()" class="action-button">Fermer</button>
        <div *ngIf="recoverSucceeded === true">
          <p class="no-margin flex align-items-center text-sm"><span class="exclamation white">!</span> Pensez à vérifier votre boîte
            mail.</p>
        </div>

        <div *ngIf="recoverSucceeded === false">
          <p class="no-margin text-center text-sm"><span class="exclamation white">!</span> Si vous pensez qu’il s’agit d’une
            erreur, contactez notre support : <a href="mailto:support_client@v8te.com"
          class="email-link">support_client&#64;v8te.com</a></p>
        </div>
      </div>

    </div>
  </div>
</div>